module.exports = __webpack_public_path__ + "static/media/PartlyCloudyDay.0f5e070c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/weather/PartlyCloudyDay.svg
// module id = 407
// module chunks = 0